import React from 'react';

import { PopUpHandler } from '@/components/popup-handler';
import { JobDetailContext } from '@/contexts';
import { JobPostingModules } from '@/domain/job-details/components';
import { JobPostingVisibleJobFragment } from '@/graphql/generated';

import SoftLoginBouncer from './components/soft-login-bouncer';
import withShare from './components/withJobShare';

const Job = withShare(({ job }) => {
  return <JobPostingModules job={job} />;
});

export const JobPostingComponent: React.FC<{ job: JobPostingVisibleJobFragment }> = ({ job }) => (
  <SoftLoginBouncer>
    <JobDetailContext.Provider value={{ id: job.id, slug: job.slug }}>
      <PopUpHandler jobLocation={job.location?.city} discipline={job.discipline}>
        <Job job={job} />
      </PopUpHandler>
    </JobDetailContext.Provider>
  </SoftLoginBouncer>
);
